import { Checkbox } from '@mui/material';
import { HeaderCellProps } from '../types';

export const DataDeletionCheckboxHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  const { allOnPageSelected, isIndeterminateOnPage, onToggleSelectAll } = _customRowProps;

  return (
    <Checkbox
      checked={allOnPageSelected}
      indeterminate={isIndeterminateOnPage}
      onChange={(e) => onToggleSelectAll((e.target as HTMLInputElement).checked)}
      inputProps={{ 'aria-label': 'select all' }}
    />
  );
};
